<template>
  <v-form
    id="redsysForm"
    ref="form"
    v-bind:action="redsysForm.url"
    method="post"
  >
    <input
      type="hidden"
      name="Ds_SignatureVersion"
      v-model="redsysForm.body.Ds_SignatureVersion"
    />
    <input
      type="hidden"
      name="Ds_MerchantParameters"
      v-model="redsysForm.body.Ds_MerchantParameters"
    />
    <input
      type="hidden"
      name="Ds_Signature"
      v-model="redsysForm.body.Ds_Signature"
    />
  </v-form>
</template>
<script>
export default {
  name: "RedsysForm",
  props: ["redsysForm"]
};
</script>
<style scoped lang="scss">
form#redsysForm {
  display: inline-block;
}
</style>
